import { Logger } from '../Logger/Logger';
var WindowManager = /** @class */ (function () {
    function WindowManager(logger) {
        if (logger === void 0) { logger = new Logger('WindowMessenger'); }
        this.logger = logger;
    }
    WindowManager.prototype.destroy = function () { };
    WindowManager.prototype.show = function () { };
    WindowManager.prototype.hide = function () { };
    return WindowManager;
}());
export { WindowManager };
//# sourceMappingURL=WindowManager.js.map